<template>
	<div class="body">
		<div class="body-container">
			<div class="content-title">
				<img class="title-wing" src="../assets/icons/title_wing_left.png" />
				<span class="title-text">{{ title }}</span>
				<img class="title-wing" src="../assets/icons/title_wing_right.png" />
			</div>
			
			<div class="paper-row" v-for="(paper, index) in list" :key="index">
				<img class="point-pic" src="../assets/icons/circle_point.png" />
				<div class="paper-title" @click="clickRoute(paper)">{{ paper.name }}</div>
			</div>


			<div class="pagination">
				<pagination v-show="total>0" :total="total" :page.sync="params.page"
					:limit.sync="params.pageSize" @pagination="requestData" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getPolicyList
	} from "@/api/policy"

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"


	export default {
		name: "Policy",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				list: [],
				total: 0,
				title: ''
			}
		},
		created() {
			this.initPageData();
		},
		methods: {
			buildParams() {
				return this.params;
			},
			
			initPageData() {
				console.log('this.$route.query', this.$route.query)
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},
			
			requestData() {
				getPolicyList(this.buildParams()).then(res => {
					this.title = res.data.title;
					this.list = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			clickRoute(item) {
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "policy_list.scss";
</style>